import PhotoSwipeLightbox from "./photoswipe-lightbox.esm.min.js";

const images = Array.from(document.querySelectorAll(".main-article__body img"));

if (images.length) {
  // Shopify CDN size suffix (_large, _medium, _600x400, ...); stripping it
  // points at the original upload, capped to 1600px via the CDN width param.
  const sizeSuffix =
    /_(?:pico|icon|thumb|small|compact|medium|large|grande|original|master|\d+x\d*|x\d+)(\.(?:jpe?g|png|gif|webp))(?=\?|$)/i;

  const probe = (src) =>
    new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () =>
        resolve({ src, width: img.naturalWidth, height: img.naturalHeight });
      img.onerror = reject;
      img.src = src;
    });

  const slides = images.map((img) => {
    const current = img.currentSrc || img.src;
    const inline = () =>
      probe(current).catch(() => ({
        src: current,
        width: img.naturalWidth || 1024,
        height: img.naturalHeight || 768,
      }));

    if (!sizeSuffix.test(current)) return inline();

    const full = new URL(current.replace(sizeSuffix, "$1"), window.location.href);
    full.searchParams.set("width", "1600");
    return probe(full.href).catch(inline);
  });

  let lightbox;
  const open = async (index) => {
    const dataSource = await Promise.all(slides);
    if (!lightbox) {
      lightbox = new PhotoSwipeLightbox({
        dataSource,
        pswpModule: () => import("./photoswipe.esm.min.js"),
        bgOpacity: 1,
      });
      lightbox.init();
    }
    lightbox.loadAndOpen(index);
  };

  images.forEach((img, index) => {
    img.setAttribute("tabindex", "0");
    img.setAttribute("role", "button");
    img.setAttribute("aria-label", "View full-size image");
    img.addEventListener("click", () => open(index));
    img.addEventListener("keydown", (event) => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        open(index);
      }
    });
  });
}
